import { render, staticRenderFns } from "./ExportReportTab.vue?vue&type=template&id=6a8fd34d&scoped=true&lang=pug"
import script from "./ExportReportTab.vue?vue&type=script&lang=ts"
export * from "./ExportReportTab.vue?vue&type=script&lang=ts"
import style0 from "./ExportReportTab.vue?vue&type=style&index=0&id=6a8fd34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fd34d",
  null
  
)

export default component.exports